import React from 'react';
import './style.scss';
import { LanguageType } from '../../../lib';
import getFormatMessage from '../../../locales/get-format-message';
import { openContactMethod } from '../../../lib/email';

interface IProps {
  readonly languageType?: LanguageType;
}

export const ContactUsTips = (props: IProps) => {
  return (
    <div className="contact-us-tips">
      <span className="tips-left">
        {getFormatMessage(
          'document_home_question',
          {},
          props.languageType || LanguageType.en_US
        )}
      </span>
      <br />
      <span className="tips-right" onClick={openContactMethod}>
        {getFormatMessage(
          'document_home_contact',
          {},
          props.languageType || LanguageType.en_US
        )}
      </span>
    </div>
  );
};
